// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__33l2D","error":"Textarea_error__Lyr08","readonly":"Textarea_readonly__pwvGS","disabled":"Textarea_disabled__3Bi_i"};